import VirtualJoyStickPlugin from 'phaser3-rex-plugins/plugins/virtualjoystick-plugin';
import { GlobalService } from 'src/app/services/global.service';
import VirtualJoyStick from 'phaser3-rex-plugins/plugins/virtualjoystick';

export class CustomJoystick extends VirtualJoyStickPlugin {
  jsFullRadius: number;
  thumbRadius: number;
  scene: Phaser.Scene;
  joystick: VirtualJoyStick;
  base: Phaser.GameObjects.Arc;
  thumb: Phaser.GameObjects.Arc;

  constructor(scene: any, jsFullRadius: number = 90, thumbRadius: number = 32.5) {
    super(scene.plugins);
    this.scene = scene;
    this.jsFullRadius = jsFullRadius*GlobalService.zoom;
    this.thumbRadius = thumbRadius*GlobalService.zoom;
    this.joystick = this.createJoystick();
  }

  createJoystick() {

    // Create base
    this.base = this.scene.add
      .circle(0, 0, this.thumbRadius * 2, 0x888888, 0.5)
      .setDepth(3);

      // Create thumb
    this.thumb = this.scene.add
      .circle(0, 0, this.thumbRadius, 0xcccccc, 0.5)
      .setDepth(3);

    // Create joystick
    const joystick = this.add(
      this.scene,
      {
        x: this.jsFullRadius + this.thumbRadius*1.5,
        y: window.innerHeight - (this.jsFullRadius + this.thumbRadius*1.5),
        radius: this.jsFullRadius,
        base: this.base,
        thumb: this.thumb,
          forceMin: 0,
      }
    ).setScrollFactor(0);
    return joystick;
  }

  // Now you can add new methods directly
  public updatePosition(){
    if(this.joystick){
      const x = this.jsFullRadius + this.thumbRadius*1.5;
      const y = window.innerHeight - (this.jsFullRadius + this.thumbRadius*1.5)  
      this.joystick.setPosition(x, y);
    }
  }
}
